import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import ZoneTable from './ZoneTable'; // Implement a table component for zones
import { addZone, getZones } from 'store/actions'; // Redux actions for zones
import CreateZone from './CreateZone'; // Modal component to create/edit zones
import Breadcrumb from 'components/Common/Breadcrumb2';

const ZoneList = () => {
    const [isOpen, setIsOpen] = useState(false); // Modal visibility
    const dispatch = useDispatch();
    const zones = useSelector((state) => state.Zone.zones); // Get zones from Redux store
    const loading = useSelector((state) => state.Zone.loading);
    const error = useSelector((state) => state.Zone.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    // Fetch zones on component mount
    useEffect(() => {
        if (loading) return;
        dispatch(getZones());
    }, [dispatch]);

    const handleSubmit = (data) => {
        dispatch(addZone(data)); // Add or update zone
    };

    const handleClose = () => {
        setIsOpen(false); // Close modal
    };

    return (
        <>
            {/* Modal for creating/editing zones */}
            <CreateZone visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />

            <div className="page-content container-fluid">
                {/* Header with breadcrumb and Add button */}
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb 
                        title="Zones" 
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` }, 
                            { title: "Zones", link: '#' }
                        ]} 
                    />
                    {permissions?.map(item => item?.permissionName)?.includes("Add Zone") && (
                        <Button 
                            className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center" 
                            onClick={() => setIsOpen(true)}
                        >
                            <i className="ti-plus"></i> Add New
                        </Button>
                    )}
                </div>

                {/* Table to display zones */}
                <ZoneTable List={zones?.Data} loading={loading} error={error} />
            </div>
        </>
    );
};

export default ZoneList;
